const dataPeriods = {
  WEEKLY: 'weekly',
  FORTNIGHTLY: 'fortnightly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
}

export default dataPeriods;
